var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0988 3C7.44979 3.00657 5.53898 3.09617 4.31783 4.31752C3 5.63556 3 7.75692 3 11.9996C3 16.2423 3 18.3637 4.31783 19.6817C5.63565 20.9998 7.75667 20.9998 11.9988 20.9998C16.2407 20.9998 18.3618 20.9998 19.6796 19.6817C20.9007 18.4604 20.9903 16.5492 20.9969 12.8997",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5561 3.496L11.0488 13.0585M20.5561 3.496C20.0621 3.00139 16.7344 3.04749 16.0309 3.0575M20.5561 3.496C21.0501 3.99062 21.004 7.32261 20.994 8.02702",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSquare);
export default __webpack_public_path__ + "static/media/LinkSquare.f1463f62c3d9b1e6424b90cc24be315f.svg";
export { ForwardRef as ReactComponent };